import React from 'react'

const AboutUs = () => {
  return (
   <h1>This is About Us Page!!! </h1>
  )
}

export default AboutUs